// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"845":"33c7cc9b","891":"2cfea15a"}[chunkId] + ".chunk.js";
};